import { BaseSelect } from '@app/components';
import { productApi } from '@app/store';
import { createColumnHelper, } from '@tanstack/react-table';
import { IProduct } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IProduct>();

export const ProductSelect = ({ label = 'Produits', ...props }: ResourceSelectParentProps<IProduct>) => {

  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="100%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={productApi.useReadManyProductsQuery}
      {...props} />
  );
};
